var _defs, _g, _g2, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceJr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "46mm",
    height: "46mm",
    viewBox: "0 0 130.3937 130.3937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.aa,.ab,.ac,.c,.d,.e,.f,.g,.h,.i,.j,.k,.l,.m,.n,.o,.p,.q,.r,.v,.w{fill:none;}.b{fill:#ffdb06;}.c,.d,.e,.w{stroke:#ff9376;}.c,.d,.e,.f,.g,.h,.i,.j,.k,.l,.m,.n,.o,.p,.q,.r{stroke-linecap:round;}.c,.d,.e{stroke-linejoin:round;}.ac,.c,.o{stroke-width:2px;}.d{stroke-width:1.5px;}.e{stroke-width:0.5px;}.ab,.f,.g,.h,.i,.j,.k,.l,.m,.n,.o,.p,.q,.r{stroke:#ffdb06;}.ab,.ac,.f,.g,.h,.i,.j,.k,.l,.m,.n,.o,.p,.q,.r,.w,.z{stroke-miterlimit:10;}.f{stroke-width:0.6px;}.g{stroke-width:0.8px;}.h{stroke-width:1.2px;}.i{stroke-width:1.4px;}.j{stroke-width:1.6px;}.k{stroke-width:1.8px;}.m{stroke-width:2.4px;}.n{stroke-width:2.2px;}.p{stroke-width:2.6px;}.q{stroke-width:3px;}.r{stroke-width:2.8px;}.s{clip-path:url(#a);}.t{fill:#db004f;}.u{opacity:0.7;fill:url(#b);}.ac,.v{stroke:#7a0032;}.aa,.v{stroke-width:12px;}.ab,.w{stroke-width:8px;}.x{clip-path:url(#c);}.y{fill:#ff7300;}.z{opacity:0.8;fill:url(#d);stroke:url(#e);}.aa{stroke:#992f20;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: -22.3645,
    y: 10.3862,
    width: 129.7161,
    height: 64.2147,
    transform: "translate(-17.6014 42.4935) rotate(-45)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "b",
    width: 106.7528,
    height: 106.7528,
    patternTransform: "translate(82.929 304.5438) rotate(-45)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 106.753 106.753"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106.7528,
    height: 106.7528
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "7.876 105.943 5.139 110.462 9.29 113.662 7.876 105.943"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "46.762 115.651 48.598 105.955 53.018 112.638"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "73.327 97.295 77.498 96.202 74.936 105.048 82.82 102.982 75.95 114.903"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 89.6456,
    y1: 111.4862,
    x2: 85.0229,
    y2: 107.156
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "100.7 108.771 101.999 115.644 104.277 107.454"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 65.606,
    y1: 113.9494,
    x2: 64.2432,
    y2: 106.6928
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 112.5773,
    y1: 64.3425,
    x2: 107.744,
    y2: 59.7056
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "100.556 90.138 112.577 93.056 106.567 87.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "5.883 20.287 8.111 11.307 13.58 16.116"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "27.441 16.866 22.464 16.608 22.319 19.409 17.341 19.151 17.196 21.952 13.15 18.934 11.913 22.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "6.139 82.134 10.379 84.753 11.853 82.367 16.093 84.986 17.567 82.6 19.664 87.192 22.699 84.23"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 41.7356,
    y1: 10.0519,
    x2: 43.8812,
    y2: 5.415
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 77.4353,
    y1: 49.6401,
    x2: 79.5808,
    y2: 45.0032
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 21.1106,
    y1: 12.6193,
    x2: 20.2272,
    y2: 9.5092
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 28.6978,
    y1: 13.192,
    x2: 27.4142,
    y2: 10.4276
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 62.4688,
    y1: 55.7816,
    x2: 65.016,
    y2: 54.1078
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "36.803 10.947 35.357 16.064 42.7 13.505"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "31.819 20.752 32.124 24.388 26.745 23.021 31.819 20.752"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "8.876 29.307 8.876 31.866 11.546 31.866 10.211 35.76 14.419 36.428"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "75.475 40.52 77.867 41.428 78.814 38.931 81.982 41.56 84.098 37.863"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 22.1052,
    y1: 32.5893,
    x2: 15.43,
    y2: 26.5816
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 27.8423,
    y1: 84.0098,
    x2: 24.2697,
    y2: 75.7705
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 23.1165,
    y1: 28.8623,
    x2: 31.0155,
    y2: 30.3086
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "38.779 19.973 44.12 19.083 42.451 22.421 48.904 21.387"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "37.444 24.638 37.426 29.578 40.949 28.213 42.548 33.5 48.33 28.86 48.835 32.665"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "54.28 56.54 55.397 61.352 58.512 59.215 61.282 63.994 65.844 58.151 67.209 61.739"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "28.902 34.994 37.357 38.906 22.242 40.508"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "18.169 39.631 11.647 41.158 19.677 47.322"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 10.2903,
    y1: 46.5125,
    x2: 6.1619,
    y2: 45.2984
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 35.4578,
    y1: 79.8603,
    x2: 31.3294,
    y2: 78.6462
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "12.226 51.959 18.419 51.076 16.082 55.069 23.677 56.595"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "25.523 45.298 30.459 47.322 27.066 48.905 32.017 50.432 30.409 55.831 33.762 56.595"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "51.378 8.732 60.343 7.137 58.362 13.053 64.124 13.053 63.427 17.447 72.751 16.435"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 50.4965,
    y1: 13.0643,
    x2: 52.0179,
    y2: 17.9735
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 52.1109,
    y1: 23.4041,
    x2: 62.9502,
    y2: 21.7365
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "55.926 27.22 55.926 37.997 62.194 31.611"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 44.6997,
    y1: 39.6312,
    x2: 50.4965,
    y2: 36.5211
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 37.3569,
    y1: 43.4764,
    x2: 40.7502,
    y2: 47.3217
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "47.427 48.905 46.632 44.268 53.16 45.905 53.16 42.465 61.336 43.476 61.336 39.631"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "65.588 27.972 72.412 29.307 66.725 33.98 76.203 34.994"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 69.9478,
    y1: 24.1371,
    x2: 70.7506,
    y2: 20.1845
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "73.138 9.002 68.971 7.456 73.032 4.015 73.138 9.002"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "10.29 61.232 10.29 67.453 14.419 65.869 10.29 61.232"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 20.6689,
    y1: 61.2324,
    x2: 28.056,
    y2: 62.8158
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "23.767 66.23 17.934 68.355 19.448 74.586 10.83 74.245"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 7.2261,
    y1: 71.2375,
    x2: 5.1619,
    y2: 76.2533
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 5.8245,
    y1: 64.3425,
    x2: 0.9913,
    y2: 59.7056
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "28.048 73.057 30.8 68.431 32.994 74.225 34.782 63.811 38.358 68.463 38.377 63.826 43.832 63.057"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "41.028 58.179 42.808 52.674 50.497 62.816"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "50.16 53.945 50.984 50.542 56.901 50.836"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 58.9014,
    y1: 47.905,
    x2: 64.588,
    y2: 49.9469
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "69.474 40.508 70.349 51.076 73.549 50.432 69.474 40.508"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "79.357 32.608 83.217 30.309 76.203 25.721 80.786 23.133 75.066 19.151"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 79.1413,
    y1: 15.6912,
    x2: 84.3541,
    y2: 14.8633
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "80.786 7.009 75.066 13.444 88.829 7.009"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "44.747 68.325 41.057 76.105 52.468 66.074"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "54.95 71.09 52.468 78.253 61.336 79.86 54.95 71.09"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 61.3359,
    y1: 68.0896,
    x2: 68.1287,
    y2: 68.0896
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "44.7 79.86 42.808 91.232 37.357 83.325"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "33.394 86.663 32.124 93.491 26.745 91.985 25.27 99.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 22.6689,
    y1: 92.9013,
    x2: 17.43,
    y2: 97.4452
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "7.72 101.284 10.513 90.709 16.097 107.439"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "7.876 105.399 5.139 109.917 9.29 113.118 7.876 105.399"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "7.876 -0.81 5.139 3.709 9.29 6.909 7.876 -0.81"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 20.6689,
    y1: 101.3989,
    x2: 19.677,
    y2: 106.6705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "25.27 103.093 28.842 106.671 30.409 103.093 34.937 106.671 35.688 97.445 43.842 106.671"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 41.0283,
    y1: 96.1273,
    x2: 46.6325,
    y2: 99.1396
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "48.26 83.136 49.113 89.192 54.761 84.134 53.16 94.056 59.089 90.103 61.336 99.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 48.2598,
    y1: 94.0563,
    x2: 50.4965,
    y2: 101.3989
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "56.916 100.14 54.16 107.671 57.531 107.671 56.916 100.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "83.217 19.151 90.646 20.185 86.931 10.563"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "92.981 7.009 91.474 11.432 97.837 14.863 94.656 23.967 99.708 24.388 98.817 32.589"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "102.7 19.799 105.524 11.432 108.16 22.161 102.7 19.799"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 95.8374,
    y1: 9.006,
    x2: 98.6998,
    y2: 7.1729
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "103.43 27.22 107.854 29.585 100.7 37.751"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 88.8292,
    y1: 27.2196,
    x2: 84.3541,
    y2: 23.9671
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 93.5454,
    y1: 26.5816,
    x2: 90.6456,
    y2: 34.9943
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "88.829 46.512 86.592 34.994 97.123 51.076"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "92.21 37.751 96.318 37.751 96.318 41.56 102.582 43.035 100.7 47.322 107.007 49.926"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 107.0069,
    y1: 37.7511,
    x2: 106.1596,
    y2: 44.2681
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "83.217 47.322 81.947 51.883 90.646 49.926"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "70.091 55.519 76.596 54.572 75.599 61.569 81.693 59.882 81.439 64.812 88.514 65.355"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 84.0978,
    y1: 56.5955,
    x2: 90.6456,
    y2: 56.5955
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "93.545 53.836 97.123 63.267 88.829 61.437"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "98.472 56.248 102.814 51.599 107.257 56.852 98.472 56.248"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "102.582 62.024 106.583 67.631 98.139 69.204 102.361 73.237 90.646 76.77 93.545 85.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "97.837 80.89 103.43 78.646 106.16 83.136"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 107.0069,
    y1: 73.2375,
    x2: 107.8541,
    y2: 76.7705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "73.549 66.016 79.786 67.334 70.349 73.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "65.588 72.475 64.742 76.253 70.349 76.86 65.588 82.01 75.066 82.01"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 59.9014,
    y1: 85.0098,
    x2: 67.1045,
    y2: 89.192
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "66.861 93.618 75.668 87.794 67.988 104.404"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 64.7424,
    y1: 99.3989,
    x2: 61.3359,
    y2: 104.6705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "46.762 115.955 48.598 106.258 53.018 112.942"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "46.762 8.898 48.598 -0.798 53.018 5.885"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "77.469 74.77 86.931 70.028 78.508 79.819"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 92.9759,
    y1: 71.0896,
    x2: 92.21,
    y2: 66.9936
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 82.2167,
    y1: 79.8186,
    x2: 87.8292,
    y2: 78.8914
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "78.508 84.663 86.297 83.546 84.098 92.056 78.508 84.663"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "73.327 -9.458 77.498 -10.55 74.936 -1.705 82.82 -3.77 75.95 8.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "73.327 97.707 77.498 96.614 74.936 105.46 82.82 103.394 75.95 115.315"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "84.354 99.14 86.931 96.99 91.474 102.905"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "90.646 94.056 90.646 89.192 96.016 91.624 98.614 84.134 101.999 86.663 101.999 84.134"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "100.7 90.138 112.721 93.056 106.71 87.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "-6.196 90.138 5.825 93.056 -0.186 87.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "93.545 97.931 98.614 95.173 98.139 102.905 106.16 102.058 104.277 105.258 110.515 106.671"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 104.2769,
    y1: 96.4452,
    x2: 109.3603,
    y2: 96.4452
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 89.6456,
    y1: 111.4862,
    x2: 85.0229,
    y2: 107.156
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 89.6456,
    y1: 4.7335,
    x2: 85.0229,
    y2: 0.4032
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 89.5917,
    y1: 106.2585,
    x2: 98.1395,
    y2: 107.6705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "100.7 2.019 101.999 8.891 104.277 0.701"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "12.354 1.848 16.542 9.289 18.768 3.919"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 65.606,
    y1: 113.9494,
    x2: 64.2432,
    y2: 106.6928
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 65.606,
    y1: 7.1966,
    x2: 64.2432,
    y2: -0.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "23.873 6.711 24.914 0.994 27.184 7.914 32.299 3.376 32.299 9.793 40.408 2.348"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 7.194,
    y1: 24.3885,
    x2: 3.4079,
    y2: 27.9723
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 5.1388,
    y1: 34.9943,
    x2: 6.1619,
    y2: 41.0096
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "7.162 50.926 6.65 56.243 4.408 52.076"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "-4.053 19.799 -1.229 11.432 1.407 22.161 -4.053 19.799"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "-3.323 27.22 1.101 29.585 -6.053 37.751"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "-14.543 37.751 -10.435 37.751 -10.435 41.56 -4.17 43.035 -6.053 47.322 0.254 49.926"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 0.2541,
    y1: 37.7511,
    x2: -0.5931,
    y2: 44.2681
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "-8.281 56.248 -3.939 51.599 0.504 56.852 -8.281 56.248"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "-4.17 62.024 -0.169 67.631 -8.613 69.204 -4.391 73.237 -16.107 76.77 -13.207 85.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "-8.915 80.89 -3.323 78.646 -0.593 83.136"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 0.2541,
    y1: 73.2375,
    x2: 1.1013,
    y2: 76.7705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "-6.053 90.138 5.968 93.056 -0.043 87.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "-13.207 97.931 -8.138 95.173 -8.613 102.905 -0.593 102.058 -2.476 105.258 3.763 106.671"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: -2.4758,
    y1: 96.4452,
    x2: 2.6075,
    y2: 96.4452
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "7.72 -5.468 10.513 -16.044 16.097 0.686"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "7.876 -1.354 5.139 3.165 9.29 6.365 7.876 -1.354"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 20.6689,
    y1: -5.3539,
    x2: 19.677,
    y2: -0.0822
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "25.27 -3.659 28.842 -0.082 30.409 -3.659 34.937 -0.082 35.688 -9.308 43.842 -0.082"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "56.916 -6.613 54.16 0.918 57.531 0.918 56.916 -6.613"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "46.762 9.202 48.598 -0.494 53.018 6.189"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "73.327 -9.046 77.498 -10.138 74.936 -1.293 82.82 -3.358 75.95 8.562"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "93.545 -8.822 98.614 -11.58 98.139 -3.848 106.16 -4.695 104.277 -1.494 110.515 -0.082"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 89.6456,
    y1: 4.7335,
    x2: 85.0229,
    y2: 0.4032
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 89.5917,
    y1: -0.4943,
    x2: 98.1395,
    y2: 0.9178
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 65.606,
    y1: 7.1966,
    x2: 64.2432,
    y2: -0.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "-13.207 -8.822 -8.138 -11.58 -8.613 -3.848 -0.593 -4.695 -2.476 -1.494 3.763 -0.082"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 23.0421,
    y: 55.7928,
    width: 129.7161,
    height: 64.2147,
    transform: "translate(-36.4094 87.9002) rotate(-45)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "d",
    width: 186.6614,
    height: 106.7528,
    patternTransform: "translate(115.267 359.9993) rotate(-45) scale(1.12)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 186.661 106.753"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 186.6614,
    height: 106.7528
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M186.8107,105.2779c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M79.8468,105.2779c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M.1492,105.2779c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-106.8146,105.2779c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M186.8107-1.4749c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.344,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M186.8107,3.162c3.4193,0,9.9248,3.0536,13.3441,3.0536S210.08,3.162,213.4989,3.162s9.9248,3.0536,13.344,3.0536S236.7677,3.162,240.187,3.162s9.9248,3.0536,13.3441,3.0536S263.01,3.162,266.8752,3.162"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M186.8107,12.434c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M186.8107,105.174c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.344,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M186.8107,17.0728c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M186.8107,21.71c3.4193,0,9.9248,3.0535,13.3441,3.0535S210.08,21.71,213.4989,21.71s9.9248,3.0535,13.344,3.0535S236.7677,21.71,240.187,21.71s9.9248,3.0535,13.3441,3.0535S263.01,21.71,266.8752,21.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M186.8107,26.3466c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S223.4237,29.4,226.8429,29.4s9.9248-3.0535,13.3441-3.0535S250.1118,29.4,253.5311,29.4s9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M186.8107,8.1079a35.8009,35.8009,0,0,1,8.4963,1.6738"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M186.8107,40.2573c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M186.8466,35.5114c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535c2.348,0,5.1533.9259,8.4131,1.8281"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M186.8466,95.9c3.4193,0,9.9248,3.0535,13.3441,3.0535S210.1155,95.9,213.5348,95.9s9.9248,3.0535,13.3441,3.0535S236.8037,95.9,240.223,95.9c2.348,0,5.1533.9259,8.4131,1.8282"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M186.8107,30.5533c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M186.8107,44.8942c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.344,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M186.7834,49.5311c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M186.75,54.168c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M186.8107,68.0788c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535c2.4919,0,5.0018,1.1764,8.3829,2.0562"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M186.8107,63.4419c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M186.7835,59.1683c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.344-3.0536,9.9249,3.0536,13.3441,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M186.8107,77.3526c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M186.8107,72.7157c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M186.8107,86.6264c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M186.8107,81.99c3.4193,0,9.9248,3.0535,13.3441,3.0535S210.08,81.99,213.4989,81.99s9.9248,3.0535,13.344,3.0535S236.7677,81.99,240.187,81.99s9.9248,3.0535,13.3441,3.0535S263.01,81.99,266.8752,81.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M186.8107,100.846c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M186.8107,91.2652c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M186.8107,95.9325a35.8016,35.8016,0,0,1,8.4963,1.6739"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M79.8468-1.4749c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S182.7342-1.4749,186.6-1.4749"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M79.8468,3.162c3.25,0,9.9248,3.0536,13.3441,3.0536S103.1157,3.162,106.535,3.162s9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S182.7342,3.162,186.6,3.162"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M79.8468,12.434c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S182.7342,12.434,186.6,12.434"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M79.8468,105.174c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M79.8468,17.0728c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M79.8468,8.1079c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S182.7342,8.1079,186.6,8.1079"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M79.8468,26.3466c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S116.46,29.4,119.8791,29.4s9.9248-3.0535,13.3441-3.0535S143.148,29.4,146.5673,29.4s9.9248-3.0535,13.3441-3.0535S169.8362,29.4,173.2555,29.4s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M79.8468,35.72c3.25,0,9.9248,3.0536,13.3441,3.0536S103.1157,35.72,106.535,35.72s9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S182.7342,35.72,186.6,35.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M177.9619,46.972c3.2224-.8936,5.8985-1.7533,8.6377-1.7533"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M79.8468,45.01c3.25,0,9.9248,3.0536,13.3441,3.0536S103.1157,45.01,106.535,45.01s9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536c2.3479,0,5.1533.9259,8.4131,1.8282"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M79.8468,40.2573c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M79.8468,30.5533c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M98.223,55.8681c3.338-.8912,5.8476-1.7,8.2848-1.7,3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.344-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M79.82,54.168c2.1968,0,4.6971.8519,7.96,1.7561"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M79.7865,49.5311c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.344,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M151.7094,69.9205c3.4654-.8393,5.5849-1.8417,8.202-1.8417,3.4193,0,9.9248,3.0535,13.3441,3.0535s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M79.8468,68.0788c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535c2.4919,0,5.0019,1.1764,8.383,2.0562"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M151.7094,23.4241c3.4654-.8394,5.5849-1.8418,8.202-1.8418,3.4193,0,9.9248,3.0535,13.3441,3.0535s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M79.8468,21.5823c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535c2.4919,0,5.0019,1.1765,8.383,2.0562"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M79.8468,63.4419c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M79.82,59.1683c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M79.8468,77.3526c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M79.8468,72.7157c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M79.8468,86.6264c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S116.46,89.68,119.8791,89.68s9.9248-3.0535,13.3441-3.0535S143.148,89.68,146.5673,89.68s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M79.8468,81.99c3.25,0,9.9248,3.0535,13.3441,3.0535S103.1157,81.99,106.535,81.99s9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S182.7342,81.99,186.6,81.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M79.8468,95.9c3.25,0,9.9248,3.0535,13.3441,3.0535S103.1157,95.9,106.535,95.9s9.9248,3.0535,13.3441,3.0535S129.8039,95.9,133.2232,95.9s9.9248,3.0535,13.3441,3.0535S156.4921,95.9,159.9114,95.9s9.9248,3.0535,13.3441,3.0535S182.7342,95.9,186.6,95.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M79.8468,91.2652c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M146.934,21.4334l.7054,1.4292a.3851.3851,0,0,0,.29.2107l1.5772.2292a.3853.3853,0,0,1,.2135.6572l-1.1413,1.1124a.3853.3853,0,0,0-.1108.341l.2694,1.5708a.3853.3853,0,0,1-.559.4062l-1.4107-.7417a.3852.3852,0,0,0-.3585,0l-1.4107.7417a.3853.3853,0,0,1-.559-.4062l.2694-1.5708a.3853.3853,0,0,0-.1108-.341L143.4569,23.96a.3853.3853,0,0,1,.2136-.6572l1.5772-.2292a.3851.3851,0,0,0,.29-.2107l.7054-1.4292A.3852.3852,0,0,1,146.934,21.4334Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M124.7313,102.5234a36.677,36.677,0,0,1,8.6386-1.6774c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M79.8468,100.846c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535a35.8023,35.8023,0,0,1,8.4964,1.6739"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M120.1818,100.6971l.7053,1.4292a.3855.3855,0,0,0,.29.2108l1.5772.2291a.3853.3853,0,0,1,.2135.6572l-1.1413,1.1124a.3856.3856,0,0,0-.1108.3411l.2695,1.5708a.3853.3853,0,0,1-.559.4061l-1.4107-.7416a.3854.3854,0,0,0-.3586,0l-1.4107.7416a.3853.3853,0,0,1-.559-.4061l.2694-1.5708a.3853.3853,0,0,0-.1108-.3411l-1.1412-1.1124a.3853.3853,0,0,1,.2135-.6572l1.5772-.2291a.3856.3856,0,0,0,.29-.2108l.7053-1.4292A.3853.3853,0,0,1,120.1818,100.6971Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M173.5041,45.398l.5889,1.1932a.3215.3215,0,0,0,.2421.1759l1.3168.1914a.3216.3216,0,0,1,.1783.5486l-.9528.9288a.3215.3215,0,0,0-.0926.2847l.225,1.3114a.3217.3217,0,0,1-.4667.3391l-1.1778-.6192a.3219.3219,0,0,0-.2993,0l-1.1778.6192a.3216.3216,0,0,1-.4667-.3391l.2249-1.3114a.3217.3217,0,0,0-.0925-.2847l-.9528-.9288a.3216.3216,0,0,1,.1783-.5486l1.3167-.1914a.3215.3215,0,0,0,.2422-.1759l.5889-1.1932A.3217.3217,0,0,1,173.5041,45.398Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M93.2775,54.7432l.6041,1.2241a.33.33,0,0,0,.2485.1806l1.3509.1962a.33.33,0,0,1,.1829.5629l-.9775.9528a.33.33,0,0,0-.0949.2921l.2307,1.3454a.33.33,0,0,1-.4788.3479L93.1351,59.21a.33.33,0,0,0-.3071,0l-1.2082.6352a.33.33,0,0,1-.4788-.3479l.2307-1.3454a.33.33,0,0,0-.0949-.2921l-.9775-.9528a.33.33,0,0,1,.1829-.5629l1.3509-.1962a.33.33,0,0,0,.2484-.1806l.6042-1.2241A.33.33,0,0,1,93.2775,54.7432Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M146.8845,68.654l.6041,1.2241a.33.33,0,0,0,.2485.18l1.3508.1963a.33.33,0,0,1,.1829.5628l-.9775.9529a.33.33,0,0,0-.0949.292l.2308,1.3455a.33.33,0,0,1-.4788.3478l-1.2083-.6352a.33.33,0,0,0-.3071,0l-1.2083.6352a.33.33,0,0,1-.4788-.3478l.2308-1.3455a.33.33,0,0,0-.0949-.292l-.9775-.9529a.33.33,0,0,1,.1829-.5628l1.3509-.1963a.33.33,0,0,0,.2484-.18l.6041-1.2241A.33.33,0,0,1,146.8845,68.654Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M.1492-1.4749c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536S63.45,1.5787,66.87,1.5787s9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M.1492,3.162c3.4193,0,9.9248,3.0536,13.3441,3.0536S23.4181,3.162,26.8374,3.162s9.9248,3.0536,13.3441,3.0536S50.1063,3.162,53.5256,3.162,63.45,6.2156,66.87,6.2156,76.3484,3.162,80.2138,3.162"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M.1492,12.434c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,15.4875,66.87,15.4875s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M.1492,105.174c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M.1492,17.0728c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,20.1263,66.87,20.1263s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M.1492,21.71c3.4193,0,9.9248,3.0535,13.3441,3.0535S23.4181,21.71,26.8374,21.71s9.9248,3.0535,13.3441,3.0535S50.1063,21.71,53.5256,21.71,63.45,24.7632,66.87,24.7632,76.3484,21.71,80.2138,21.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M.1492,26.3466c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S36.7622,29.4,40.1815,29.4s9.9248-3.0535,13.3441-3.0535S63.45,29.4,66.87,29.4s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M18.3456,9.7852a36.6744,36.6744,0,0,1,8.6386-1.6773c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M.1492,8.1079A35.8006,35.8006,0,0,1,8.6456,9.7817"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M.1492,40.2573c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,43.3108,66.87,43.3108s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M71.6121,37.4737C74.8345,36.58,77.5107,35.72,80.25,35.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M.1852,35.5114c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535c2.348,0,5.1533.9259,8.4131,1.8281"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M71.6121,97.8625c3.2224-.8935,5.8986-1.7532,8.6377-1.7532"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M.1852,95.9c3.4193,0,9.9248,3.0535,13.3441,3.0535S23.4541,95.9,26.8734,95.9s9.9248,3.0535,13.3441,3.0535S50.1423,95.9,53.5616,95.9c2.348,0,5.1533.9259,8.4131,1.8282"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M.1492,30.5533c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,33.6068,66.87,33.6068s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M.1492,44.8942c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536S63.45,47.9478,66.87,47.9478s9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M.122,49.5311c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M.0889,54.168c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S50.046,54.168,53.4653,54.168s9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M45.3236,69.9205c3.4654-.8393,5.585-1.8417,8.202-1.8417,3.4193,0,9.9248,3.0535,13.3441,3.0535s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M.1492,68.0788c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535c2.492,0,5.0019,1.1764,8.383,2.0562"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M.1492,63.4419c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,66.4954,66.87,66.4954s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M.1221,59.1683c3.4192,0,9.9248,3.0536,13.344,3.0536S23.391,59.1683,26.81,59.1683s9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M.1492,77.3526c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,80.4061,66.87,80.4061s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M.1492,72.7157c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,75.7692,66.87,75.7692s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M.1492,86.6264c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S36.7622,89.68,40.1815,89.68s9.9248-3.0535,13.3441-3.0535S63.45,89.68,66.87,89.68s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M.1492,81.99c3.4193,0,9.9248,3.0535,13.3441,3.0535S23.4181,81.99,26.8374,81.99s9.9248,3.0535,13.3441,3.0535S50.1063,81.99,53.5256,81.99,63.45,85.043,66.87,85.043,76.3484,81.99,80.2138,81.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M.1492,100.846c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S36.7622,103.9,40.1815,103.9s9.9248-3.0535,13.3441-3.0535S63.45,103.9,66.87,103.9s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M.1492,91.2652c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,94.3187,66.87,94.3187s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.796,7.959l.7053,1.4291a.3852.3852,0,0,0,.29.2108l1.5772.2292a.3852.3852,0,0,1,.2135.6571l-1.1412,1.1125a.385.385,0,0,0-.1108.341L15.6,13.51a.3853.3853,0,0,1-.559.4062L13.63,13.174a.3854.3854,0,0,0-.3586,0l-1.4106.7417a.3853.3853,0,0,1-.559-.4062l.2694-1.5708a.3853.3853,0,0,0-.1108-.341l-1.1413-1.1125a.3852.3852,0,0,1,.2135-.6571L12.11,9.5989a.385.385,0,0,0,.29-.2108L13.105,7.959A.3853.3853,0,0,1,13.796,7.959Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M.1492,95.9325a35.8014,35.8014,0,0,1,8.4964,1.6739"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.1251,95.7836l.7054,1.4292a.3851.3851,0,0,0,.29.2107l1.5772.2292a.3853.3853,0,0,1,.2135.6572L68.77,99.4223a.3854.3854,0,0,0-.1108.341l.2694,1.5709a.3852.3852,0,0,1-.559.4061l-1.4107-.7416a.3852.3852,0,0,0-.3585,0L65.19,101.74a.3853.3853,0,0,1-.559-.4061L64.9,99.7633a.3854.3854,0,0,0-.1108-.341L63.648,98.31a.3853.3853,0,0,1,.2136-.6572l1.5772-.2292a.3851.3851,0,0,0,.29-.2107l.7054-1.4292A.3852.3852,0,0,1,67.1251,95.7836Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.0946,35.3744l.643,1.3028a.3515.3515,0,0,0,.2645.1922l1.4378.2089a.3512.3512,0,0,1,.1946.5991l-1.04,1.0141a.3514.3514,0,0,0-.101.3109l.2456,1.432a.3512.3512,0,0,1-.51.37l-1.286-.6761a.3512.3512,0,0,0-.3269,0l-1.286.6761a.3512.3512,0,0,1-.51-.37l.2456-1.432a.3511.3511,0,0,0-.101-.3109l-1.04-1.0141a.3512.3512,0,0,1,.1947-.5991l1.4378-.2089a.3515.3515,0,0,0,.2644-.1922l.643-1.3028A.3512.3512,0,0,1,67.0946,35.3744Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.4987,68.654l.6041,1.2241a.33.33,0,0,0,.2485.18l1.3509.1963a.33.33,0,0,1,.1829.5628l-.9775.9529a.33.33,0,0,0-.0949.292l.2307,1.3455a.33.33,0,0,1-.4788.3478l-1.2082-.6352a.33.33,0,0,0-.3072,0l-1.2082.6352a.33.33,0,0,1-.4788-.3478l.2307-1.3455a.33.33,0,0,0-.0949-.292l-.9775-.9529a.33.33,0,0,1,.1829-.5628l1.3509-.1963a.33.33,0,0,0,.2484-.18l.6042-1.2241A.33.33,0,0,1,40.4987,68.654Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-106.8146-1.4749c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S-30.1693-1.4749-26.75-1.4749s9.9248,3.0536,13.3441,3.0536S-3.9272-1.4749-.0618-1.4749"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-106.8146,3.162c3.25,0,9.9248,3.0536,13.3441,3.0536S-83.5457,3.162-80.1264,3.162s9.9248,3.0536,13.3441,3.0536S-56.8575,3.162-53.4382,3.162s9.9248,3.0536,13.3441,3.0536S-30.1693,3.162-26.75,3.162s9.9248,3.0536,13.3441,3.0536S-3.9272,3.162-.0618,3.162"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-106.8146,12.434c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S-30.1693,12.434-26.75,12.434s9.9248,3.0535,13.3441,3.0535S-3.9272,12.434-.0618,12.434"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-106.8146,105.174c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-106.8146,17.0728c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M-106.8146,8.1079c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S-30.1693,8.1079-26.75,8.1079s9.9248,3.0535,13.3441,3.0535S-3.9272,8.1079-.0618,8.1079"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M-106.8146,26.3466c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S-70.2016,29.4-66.7823,29.4s9.9248-3.0535,13.3441-3.0535S-43.5134,29.4-40.0941,29.4s9.9248-3.0535,13.3441-3.0535S-16.8252,29.4-13.4059,29.4s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M-106.8146,35.72c3.25,0,9.9248,3.0536,13.3441,3.0536S-83.5457,35.72-80.1264,35.72s9.9248,3.0536,13.3441,3.0536S-56.8575,35.72-53.4382,35.72s9.9248,3.0536,13.3441,3.0536S-30.1693,35.72-26.75,35.72s9.9248,3.0536,13.3441,3.0536S-3.9272,35.72-.0618,35.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M-8.6995,46.972c3.2224-.8936,5.8985-1.7533,8.6377-1.7533"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M-106.8146,40.2573c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M-106.8146,30.5533c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M-88.4384,55.8681c3.3379-.8912,5.8475-1.7,8.2848-1.7,3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.344,3.0536,9.9249-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S-3.9544,54.168-.0891,54.168"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M-106.8749,49.5311c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.344,3.0536,9.9249-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S-30.23,49.5311-26.81,49.5311s9.9248,3.0536,13.3441,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M-34.9521,69.9205c3.4655-.8393,5.585-1.8417,8.2021-1.8417,3.4193,0,9.9248,3.0535,13.3441,3.0535s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M-34.9521,23.4241c3.4655-.8394,5.585-1.8418,8.2021-1.8418,3.4193,0,9.9248,3.0535,13.3441,3.0535s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M-106.8146,63.4419c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M-106.8418,59.1683c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S-3.9544,59.1683-.089,59.1683"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M-106.8146,77.3526c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M-106.8146,72.7157c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-106.8146,86.6264c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S-70.2016,89.68-66.7823,89.68s9.9248-3.0535,13.3441-3.0535S-43.5134,89.68-40.0941,89.68s9.9248-3.0535,13.3441-3.0535S-16.8252,89.68-13.4059,89.68s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M-106.8146,81.99c3.25,0,9.9248,3.0535,13.3441,3.0535S-83.5457,81.99-80.1264,81.99s9.9248,3.0535,13.3441,3.0535S-56.8575,81.99-53.4382,81.99s9.9248,3.0535,13.3441,3.0535S-30.1693,81.99-26.75,81.99s9.9248,3.0535,13.3441,3.0535S-3.9272,81.99-.0618,81.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M-106.8146,95.9c3.25,0,9.9248,3.0535,13.3441,3.0535S-83.5457,95.9-80.1264,95.9s9.9248,3.0535,13.3441,3.0535S-56.8575,95.9-53.4382,95.9s9.9248,3.0535,13.3441,3.0535S-30.1693,95.9-26.75,95.9s9.9248,3.0535,13.3441,3.0535S-3.9272,95.9-.0618,95.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-106.8146,91.2652c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-61.93,102.5234a36.677,36.677,0,0,1,8.6386-1.6774c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S-16.6785,103.9-13.2592,103.9-3.78,100.846.0849,100.846"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M186.8107-1.5787c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M79.8468-1.5787c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S182.7342-1.5787,186.6-1.5787"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M.1492-1.5787c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,1.4748,66.87,1.4748s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-106.8146-1.5787c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S-30.1693-1.5787-26.75-1.5787s9.9248,3.0535,13.3441,3.0535S-3.9272-1.5787-.0618-1.5787"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "e",
    width: 106.7528,
    height: 106.7528,
    patternTransform: "translate(274.5348 375.6248) rotate(135)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 106.753 106.753"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106.7528,
    height: 106.7528
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,110.382c-2.6972,0-6.1474-1.1259-10.1416-2.43-4.9238-1.607-10.5048-3.4283-15.7939-3.4283-3.9238,0-7.6953,1.295-11.6865,2.6656-4.57,1.57-9.2959,3.1928-14.9131,3.1928-5.7617,0-11.5664-1.5844-17.1807-3.1167-5.166-1.41-10.0459-2.7417-14.4912-2.7417-4.7558,0-8.72,1.6133-12.5527,3.1739-3.3916,1.38-6.5948,2.6845-9.9922,2.6845v-1.4c3.123,0,6.2031-1.2534,9.4639-2.581,3.7734-1.5361,8.0507-3.2774,13.081-3.2774,4.6328,0,9.6006,1.356,14.86,2.7916,5.5244,1.5078,11.2373,3.0668,16.8115,3.0668,5.3828,0,9.9961-1.5839,14.458-3.1162,4.1055-1.41,7.9834-2.7422,12.1416-2.7422,5.5117,0,11.2051,1.8584,16.2285,3.4981,3.8809,1.2666,7.2324,2.36,9.707,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,51.7758c-5.6855,0-9.289-1.5059-12.7734-2.9629-2.9932-1.2505-5.8193-2.4322-9.6963-2.4322-6.4931,0-13.2783,1.668-19.2646,3.1392-4.9258,1.2105-9.18,2.2559-12.5508,2.2559-6.95,0-12.62-1.524-18.1035-2.9976-4.586-1.2329-8.918-2.3975-13.3682-2.3975a23.3277,23.3277,0,0,0-10.8467,2.7525A22.1285,22.1285,0,0,1,.0005,51.7758v-.8c4.26,0,6.957-1.2476,9.8125-2.5689a24.0067,24.0067,0,0,1,11.1826-2.8262c4.5557,0,8.9375,1.1778,13.5762,2.4244,5.4326,1.46,11.0508,2.9707,17.8955,2.9707,3.2744,0,7.4844-1.0347,12.3594-2.2329,6.03-1.4825,12.8652-3.1622,19.456-3.1622,4.0371,0,6.9356,1.2115,10.0049,2.4942a29.2756,29.2756,0,0,0,12.4648,2.9009Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.3765,47.1224c-7.0909,0-12.6709-1.8969-17.5928-3.57-3.8291-1.3012-7.1358-2.4253-10.4131-2.4253a30.3524,30.3524,0,0,0-12.3164,2.41A32.461,32.461,0,0,1,.0005,46.0678v-1.4A30.8783,30.8783,0,0,0,12.562,42.2255a31.9175,31.9175,0,0,1,12.8086-2.4991c3.5088,0,6.917,1.1587,10.8633,2.5005,4.82,1.6382,10.2832,3.4952,17.1426,3.4952,5.2343,0,10.333-1.5552,15.2636-3.0591,4.95-1.51,9.626-2.9366,14.4512-2.9366a26.1151,26.1151,0,0,1,12.1572,2.5352,24.4406,24.4406,0,0,0,11.5039,2.4058v1.4A25.9187,25.9187,0,0,1,94.69,43.5453a24.63,24.63,0,0,0-11.5986-2.4185c-4.6172,0-9.1953,1.3965-14.043,2.875C64.02,45.536,58.82,47.1224,53.3765,47.1224Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,41.6224c-2.7451,0-6.2158-1.1328-10.2353-2.4448-4.9024-1.6-10.459-3.4136-15.7-3.4136-3.874,0-7.6221,1.2872-11.59,2.65-4.5928,1.5772-9.3428,3.2085-15.01,3.2085-5.8018,0-11.627-1.59-17.26-3.1269C31.811,37.0907,26.9507,35.764,22.5454,35.764c-4.6973,0-8.6338,1.6021-12.44,3.1519C6.686,40.308,3.4565,41.6224.0005,41.6224v-2c3.0644,0,6.1182-1.2431,9.3506-2.559,3.8-1.5464,8.1054-3.2994,13.1943-3.2994,4.6729,0,9.6592,1.3609,14.94,2.8018,5.5048,1.5029,11.1982,3.0566,16.7324,3.0566,5.333,0,9.9219-1.5761,14.36-3.1,4.13-1.4184,8.0313-2.7583,12.2393-2.7583,5.56,0,11.2773,1.8663,16.3213,3.5127,3.8564,1.2588,7.1875,2.3457,9.6142,2.3457Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,3.6293c-2.6972,0-6.1474-1.126-10.1416-2.43C91.687-.4078,86.106-2.2291,80.8169-2.2291c-3.9238,0-7.6953,1.2949-11.6865,2.6655-4.57,1.57-9.2959,3.1929-14.9131,3.1929-5.7617,0-11.5664-1.5845-17.1807-3.1167-5.166-1.41-10.0459-2.7417-14.4912-2.7417-4.7558,0-8.72,1.6133-12.5527,3.1738C6.6011,2.3251,3.3979,3.6293.0005,3.6293v-1.4c3.123,0,6.2031-1.2534,9.4639-2.5811,3.7734-1.5361,8.0507-3.2773,13.081-3.2773,4.6328,0,9.6006,1.3559,14.86,2.7915C42.93.67,48.6431,2.2289,54.2173,2.2289c5.3828,0,9.9961-1.584,14.458-3.1162,4.1055-1.41,7.9834-2.7422,12.1416-2.7422,5.5117,0,11.2051,1.8584,16.2285,3.498,3.8809,1.2666,7.2324,2.36,9.707,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,110.3822c-2.6972,0-6.1474-1.126-10.1416-2.43-4.9238-1.6069-10.5048-3.4282-15.7939-3.4282-3.9238,0-7.6953,1.2949-11.6865,2.6655-4.57,1.57-9.2959,3.1929-14.9131,3.1929-5.7617,0-11.5664-1.5845-17.1807-3.1167-5.166-1.41-10.0459-2.7417-14.4912-2.7417-4.7558,0-8.72,1.6133-12.5527,3.1738-3.3916,1.38-6.5948,2.6846-9.9922,2.6846v-1.4c3.123,0,6.2031-1.2534,9.4639-2.581,3.7734-1.5362,8.0507-3.2774,13.081-3.2774,4.6328,0,9.6006,1.356,14.86,2.7915,5.5244,1.5078,11.2373,3.0669,16.8115,3.0669,5.3828,0,9.9961-1.584,14.458-3.1162,4.1055-1.41,7.9834-2.7422,12.1416-2.7422,5.5117,0,11.2051,1.8584,16.2285,3.4981,3.8809,1.2666,7.2324,2.36,9.707,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.3765,36.5248c-7.2071,0-12.8448-1.9165-17.8184-3.6069-3.7705-1.2818-7.0264-2.3887-10.1875-2.3887A29.7583,29.7583,0,0,0,13.3,32.8944,33.0563,33.0563,0,0,1,.0005,35.47v-2.8a30.2865,30.2865,0,0,0,12.3154-2.3975,32.517,32.517,0,0,1,13.0547-2.5434c3.624,0,7.25,1.2324,11.0889,2.5371,4.7685,1.6211,10.1728,3.4585,16.917,3.4585,5.13,0,10.1777-1.54,15.06-3.0293,4.7813-1.4585,9.7256-2.9663,14.6553-2.9663a26.7176,26.7176,0,0,1,12.4365,2.5928A23.8433,23.8433,0,0,0,106.7524,32.67v2.8a26.5216,26.5216,0,0,1-12.3418-2.58,24.0342,24.0342,0,0,0-11.3193-2.3608c-4.5127,0-9.042,1.3818-13.8379,2.8447C64.1753,34.9232,58.9243,36.5248,53.3765,36.5248Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,31.4144A31.455,31.455,0,0,1,93.4771,28.351c-2.9932-1.251-5.5782-2.3316-9.1944-2.3316-5.7236,0-10.86,1.3648-15.8271,2.6846-5.0147,1.3325-10.1993,2.71-15.9883,2.71-7.16,0-12.2949-1.6279-16.8252-3.0634-3.9463-1.2515-7.3555-2.3316-11.5957-2.3316-4.6817,0-8.2393,1.3042-12.0068,2.6856C8.4067,30.037,4.65,31.4144.0005,31.4144v-3.4c4.0459,0,7.36-1.2148,10.8691-2.5014,3.88-1.4224,7.8916-2.8936,13.1768-2.8936,4.7666,0,8.583,1.21,12.623,2.4908,4.5049,1.4277,9.1641,2.9042,15.7979,2.9042,5.3447,0,10.0908-1.2607,15.1152-2.5957,5.1778-1.3764,10.5332-2.7993,16.7-2.7993,4.2979,0,7.4541,1.3194,10.5059,2.5948a28.19,28.19,0,0,0,11.9638,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.3765,26.4193c-7.3223,0-13.0186-1.9365-18.044-3.6445-3.7109-1.2617-6.916-2.3511-9.9619-2.3511a26.3116,26.3116,0,0,0-11.7471,2.5894,30.6946,30.6946,0,0,1-13.623,2.955v-4.2a26.7887,26.7887,0,0,0,11.9922-2.6255,30.2108,30.2108,0,0,1,13.3779-2.919c3.74,0,7.419,1.25,11.3135,2.5747,4.7178,1.6035,10.0644,3.4209,16.6924,3.4209,5.0078,0,9.6894-1.5107,14.2158-2.9721,4.5576-1.4712,9.27-2.9922,14.3213-2.9922a28.7342,28.7342,0,0,1,13.3135,2.9414,24.6564,24.6564,0,0,0,11.5253,2.5718v4.2a28.54,28.54,0,0,1-13.2158-2.9272,24.8487,24.8487,0,0,0-11.623-2.5859c-4.3907,0-8.5879,1.3545-13.0313,2.789C64.0464,24.8051,59.0454,26.4193,53.3765,26.4193Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,20.6639c-4.0136,0-7.7441-1.3569-11.6933-2.7929-4.1084-1.4937-8.3565-3.0381-13.1182-3.0381-3.7754,0-7.7285,1.2676-11.914,2.61-4.9375,1.5835-10.044,3.2211-15.81,3.2211-5.9111,0-11.4209-1.6064-16.75-3.16-4.7617-1.3882-9.2588-2.6987-13.5557-2.6987-4.5869,0-8.8515,1.5854-12.9765,3.1186-3.7891,1.4087-7.3682,2.74-10.9346,2.74v-3.4c2.9551,0,6.2558-1.2271,9.75-2.5264,4.2012-1.5615,8.9629-3.332,14.1611-3.332,4.7822,0,9.5059,1.3769,14.5069,2.8349,5.1,1.4863,10.374,3.0235,15.7988,3.0235,5.2344,0,10.082-1.5547,14.7715-3.0586,4.4453-1.4258,8.6455-2.7725,12.9521-2.7725,5.3613,0,10.1,1.7231,14.2793,3.2432,3.66,1.331,7.1172,2.5879,10.5322,2.5879Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,15.25A31.19,31.19,0,0,1,93.5933,12.21C90.57,10.9462,87.96,9.8549,84.2827,9.8549c-6.3887,0-12.8379,1.4257-18.5273,2.684-4.7774,1.0562-8.9033,1.9683-12.3789,1.9683-7.11,0-12.7862-1.7627-17.793-3.3179C31.3335,9.869,27.32,8.6224,23.03,8.6224c-4.6621,0-7.9629,1.5967-11.4561,3.2872C8.1792,13.5521,4.6685,15.25.0005,15.25v-2.8c4.0264,0,7.1-1.4868,10.3535-3.0611C13.978,7.6356,17.7251,5.8226,23.03,5.8226c4.7148,0,8.9258,1.3077,13.3838,2.6924,5.0527,1.5694,10.2773,3.1924,16.9629,3.1924,3.17,0,7.1572-.8818,11.7744-1.9028,5.8291-1.2886,12.4365-2.75,19.1318-2.75,4.2383,0,7.3652,1.3071,10.39,2.5717a28.4477,28.4477,0,0,0,12.08,2.8238Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.3765,8.9657c-7.1407,0-12.7452-1.9053-17.69-3.5859-3.8037-1.293-7.0889-2.41-10.3164-2.41A30.0928,30.0928,0,0,0,13.16,5.3607,32.7078,32.7078,0,0,1,.0005,7.911v-2a30.6257,30.6257,0,0,0,12.456-2.4228A32.1767,32.1767,0,0,1,25.3706.97c3.5586,0,7.1533,1.2222,10.96,2.5161,4.7978,1.6309,10.2363,3.48,17.0459,3.48,5.1894,0,10.2666-1.5488,15.1767-3.0464C73.3062,2.47,78.2212.97,83.0913.97A26.3611,26.3611,0,0,1,95.3677,3.53,24.1944,24.1944,0,0,0,106.7524,5.911v2A26.1847,26.1847,0,0,1,94.57,5.3641,24.3648,24.3648,0,0,0,83.0913,2.97c-4.5723,0-9.13,1.39-13.9551,2.8623C64.0864,7.3729,58.8638,8.9657,53.3765,8.9657Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,105.1483c-5.6855,0-9.289-1.5063-12.7734-2.9629-2.9932-1.2509-5.8193-2.4326-9.6963-2.4326-6.4931,0-13.2783,1.668-19.2646,3.1392-4.9258,1.2109-9.18,2.2563-12.5508,2.2563-6.95,0-12.62-1.5239-18.1035-2.998-4.586-1.2329-8.918-2.3975-13.3682-2.3975a23.3214,23.3214,0,0,0-10.8467,2.7529A22.1273,22.1273,0,0,1,.0005,105.1483v-.8c4.26,0,6.957-1.248,9.8125-2.5688A23.9991,23.9991,0,0,1,20.9956,98.953c4.5557,0,8.9375,1.1777,13.5762,2.4248,5.4326,1.4605,11.0508,2.9707,17.8955,2.9707,3.2744,0,7.4844-1.0351,12.3594-2.2334,6.03-1.4819,12.8652-3.1621,19.456-3.1621,4.0371,0,6.9356,1.2114,10.0049,2.4942,3.4111,1.4262,6.9395,2.9013,12.4648,2.9013Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.3765,101.4945c-7.0909,0-12.6709-1.8965-17.5928-3.57-3.8291-1.3018-7.1358-2.4253-10.4131-2.4253a30.3507,30.3507,0,0,0-12.3164,2.41A32.4612,32.4612,0,0,1,.0005,100.44v-1.4A30.8766,30.8766,0,0,0,12.562,96.598a31.9178,31.9178,0,0,1,12.8086-2.499c3.5088,0,6.917,1.1587,10.8633,2.5,4.82,1.6382,10.2832,3.4951,17.1426,3.4951,5.2343,0,10.333-1.5552,15.2636-3.0591,4.95-1.51,9.626-2.936,14.4512-2.936a26.1151,26.1151,0,0,1,12.1572,2.5352A24.4409,24.4409,0,0,0,106.7524,99.04v1.4A25.919,25.919,0,0,1,94.69,97.9179a24.63,24.63,0,0,0-11.5986-2.4185c-4.6172,0-9.1953,1.3965-14.043,2.875C64.02,99.9081,58.82,101.4945,53.3765,101.4945Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,96.9711c-2.7451,0-6.2158-1.1328-10.2353-2.4448-4.9024-1.6-10.459-3.4136-15.7-3.4136-3.874,0-7.6221,1.2871-11.59,2.65-4.5928,1.5771-9.3428,3.2085-15.01,3.2085-5.8018,0-11.627-1.59-17.26-3.127-5.1465-1.4048-10.0068-2.7314-14.4121-2.7314-4.6973,0-8.6338,1.602-12.44,3.1518C6.686,95.6566,3.4565,96.9711.0005,96.9711v-2c3.0644,0,6.1182-1.2432,9.3506-2.5591,3.8-1.5464,8.1054-3.2993,13.1943-3.2993,4.6729,0,9.6592,1.3608,14.94,2.8017,5.5048,1.503,11.1982,3.0567,16.7324,3.0567,5.333,0,9.9219-1.5762,14.36-3.1,4.13-1.4185,8.0313-2.7583,12.2393-2.7583,5.56,0,11.2773,1.8662,16.3213,3.5127,3.8564,1.2588,7.1875,2.3457,9.6142,2.3457Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,58.1249c-2.6972,0-6.1474-1.126-10.1416-2.43-4.9238-1.6069-10.5048-3.4282-15.7939-3.4282-3.9238,0-7.6953,1.2949-11.6865,2.6655-4.57,1.57-9.2959,3.1929-14.9131,3.1929-5.7617,0-11.5664-1.5845-17.1807-3.1167-5.166-1.41-10.0459-2.7417-14.4912-2.7417-4.7558,0-8.72,1.6133-12.5527,3.1738-3.3916,1.38-6.5948,2.6846-9.9922,2.6846v-1.4c3.123,0,6.2031-1.2534,9.4639-2.5811,3.7734-1.5361,8.0507-3.2773,13.081-3.2773,4.6328,0,9.6006,1.356,14.86,2.7915,5.5244,1.5078,11.2373,3.0669,16.8115,3.0669,5.3828,0,9.9961-1.584,14.458-3.1162,4.1055-1.41,7.9834-2.7422,12.1416-2.7422,5.5117,0,11.2051,1.8584,16.2285,3.498,3.8809,1.2666,7.2324,2.36,9.707,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.3765,92.8969c-7.2071,0-12.8448-1.9161-17.8184-3.607-3.7705-1.2812-7.0264-2.3882-10.1875-2.3882A29.7581,29.7581,0,0,0,13.3,89.267a33.0563,33.0563,0,0,1-13.3,2.5757v-2.8a30.2865,30.2865,0,0,0,12.3154-2.3975,32.5168,32.5168,0,0,1,13.0547-2.5435c3.624,0,7.25,1.2325,11.0889,2.5371,4.7685,1.6207,10.1728,3.4581,16.917,3.4581,5.13,0,10.1777-1.54,15.06-3.0289,4.7813-1.4584,9.7256-2.9663,14.6553-2.9663a26.7189,26.7189,0,0,1,12.4365,2.5928,23.8431,23.8431,0,0,0,11.2246,2.3482v2.8a26.5228,26.5228,0,0,1-12.3418-2.58,24.0328,24.0328,0,0,0-11.3193-2.3609c-4.5127,0-9.042,1.3819-13.8379,2.8448C64.1753,91.2953,58.9243,92.8969,53.3765,92.8969Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,87.787c-4.7949,0-8.5332-1.4565-12.1474-2.8652-3.34-1.3013-6.4942-2.53-10.3223-2.53-6.3359,0-13.04,1.6474-18.9551,3.1016-5.0068,1.2309-9.332,2.2939-12.86,2.2939-7.1777,0-12.4248-1.7778-17.0537-3.3462-4.0244-1.3633-7.5-2.54-11.7227-2.54-4.6484,0-8.1045,1.4165-11.7637,2.9165-3.5615,1.46-7.2441,2.97-11.9267,2.97v-3.4c4.0127,0,7.2305-1.3188,10.6377-2.7158C14.4409,80.1122,18.3726,78.5,23.6909,78.5c4.7832,0,8.6836,1.3218,12.8135,2.7207,4.5947,1.5566,9.3457,3.166,15.9629,3.166,3.1172,0,7.456-1.0664,12.0488-2.1953,6.1026-1.5,13.0186-3.2,19.7666-3.2,4.4668,0,8.0713,1.4043,11.5567,2.7627,3.4746,1.354,6.7568,2.6328,10.913,2.6328Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.3765,82.3c-7.3223,0-13.0186-1.9365-18.044-3.6446-3.7109-1.2617-6.916-2.351-9.9619-2.351a29.1644,29.1644,0,0,0-11.8242,2.32A33.6509,33.6509,0,0,1,.0005,81.2455v-4.2A29.6983,29.6983,0,0,0,12.07,74.6928a33.1145,33.1145,0,0,1,13.3008-2.5884c3.74,0,7.419,1.2505,11.3135,2.5747C41.4019,76.2826,46.7485,78.1,53.3765,78.1c5.0254,0,10.0224-1.5244,14.8554-2.9986,4.83-1.4731,9.8252-2.997,14.8594-2.997a27.3005,27.3005,0,0,1,12.7149,2.6513,23.2632,23.2632,0,0,0,10.9462,2.29v4.2a27.1274,27.1274,0,0,1-12.6211-2.6382,23.4334,23.4334,0,0,0-11.04-2.3027c-4.4082,0-8.89,1.3667-13.6338,2.8144C64.33,80.683,59.0278,82.3,53.3765,82.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,75.9047c-2.8564,0-6.3759-1.149-10.4521-2.48-4.8525-1.584-10.3535-3.3789-15.4834-3.3789-3.7578,0-7.4512,1.2685-11.3623,2.6113-4.6475,1.5962-9.4531,3.2471-15.2373,3.2471-5.8955,0-11.7666-1.6026-17.4434-3.1519-5.1006-1.3921-9.917-2.7065-14.2285-2.7065-4.5605,0-8.4316,1.5757-12.1758,3.1C6.8853,74.5648,3.5933,75.9047.0005,75.9047v-3.4c2.9277,0,5.9189-1.2178,9.0869-2.5073,3.8584-1.57,8.2324-3.3511,13.458-3.3511,4.7666,0,9.7979,1.373,15.1231,2.8266,5.4619,1.4908,11.1084,3.0318,16.5488,3.0318,5.2158,0,9.749-1.5567,14.1328-3.062,4.1875-1.438,8.1416-2.7964,12.4668-2.7964,5.6709,0,11.4443,1.8847,16.5381,3.5473,3.6416,1.1885,7.082,2.3111,9.3974,2.3111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,69.746a31.1913,31.1913,0,0,1-13.1591-3.04c-3.0235-1.2637-5.6338-2.355-9.3106-2.355-6.3721,0-13.0947,1.6523-19.0264,3.11-4.9882,1.2261-9.2968,2.2852-12.789,2.2852-7.082,0-13.0752-1.6109-18.3633-3.0322-4.52-1.2154-8.79-2.3633-13.1084-2.3633a22.2012,22.2012,0,0,0-10.4268,2.6606A22.9661,22.9661,0,0,1,.0005,69.746v-2.8c4.0391,0,6.64-1.2031,9.3926-2.4766a24.8391,24.8391,0,0,1,11.6025-2.9189c4.6875,0,9.1309,1.1943,13.8359,2.459,5.37,1.4438,10.9229,2.9365,17.6358,2.9365,3.1533,0,7.5088-1.0708,12.1211-2.2041,6.0849-1.4961,12.9824-3.1914,19.6943-3.1914,4.2383,0,7.3652,1.3071,10.39,2.5717a28.4477,28.4477,0,0,0,12.08,2.8238Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.3765,63.4613c-7.1407,0-12.7452-1.9053-17.69-3.5859-3.8037-1.293-7.0889-2.41-10.3164-2.41A30.0928,30.0928,0,0,0,13.16,59.8563a32.7078,32.7078,0,0,1-13.1592,2.55v-2a30.6257,30.6257,0,0,0,12.456-2.4228,32.1767,32.1767,0,0,1,12.9141-2.5181c3.5586,0,7.1533,1.2222,10.96,2.5161,4.7978,1.6309,10.2363,3.48,17.0459,3.48,5.1894,0,10.2666-1.5488,15.1767-3.0464,4.753-1.45,9.668-2.9492,14.5381-2.9492a26.3611,26.3611,0,0,1,12.2764,2.56,24.1944,24.1944,0,0,0,11.3847,2.3808v2A26.1862,26.1862,0,0,1,94.57,59.86a24.3633,24.3633,0,0,0-11.4785-2.3941c-4.5723,0-9.13,1.39-13.9551,2.8623C64.0864,61.8685,58.8638,63.4613,53.3765,63.4613Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,3.63c-2.6972,0-6.1474-1.126-10.1416-2.43C91.687-.4077,86.106-2.2289,80.8169-2.2289,76.8931-2.2289,73.1216-.934,69.13.4366,64.56,2.0064,59.8345,3.63,54.2173,3.63,48.4556,3.63,42.6509,2.045,37.0366.5128c-5.166-1.41-10.0459-2.7417-14.4912-2.7417-4.7558,0-8.72,1.6132-12.5527,3.1738C6.6011,2.3253,3.3979,3.63.0005,3.63v-1.4c3.123,0,6.2031-1.2535,9.4639-2.5811,3.7734-1.5361,8.0507-3.2773,13.081-3.2773,4.6328,0,9.6006,1.3559,14.86,2.7915C42.93.67,48.6431,2.2291,54.2173,2.2291c5.3828,0,9.9961-1.584,14.458-3.1162,4.1055-1.41,7.9834-2.7422,12.1416-2.7422,5.5117,0,11.2051,1.8584,16.2285,3.498,3.8809,1.2666,7.2324,2.36,9.707,2.36Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "s"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "t",
    cx: 65.257,
    cy: 65.1367,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "u",
    cx: 65.257,
    cy: 65.1367,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "v",
    cx: 65.257,
    cy: 65.1367,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "w",
    cx: 65.257,
    cy: 65.1367,
    r: 57.7278
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "x"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "y",
    cx: 65.257,
    cy: 65.1367,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "z",
    cx: 65.257,
    cy: 65.1367,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "aa",
    cx: 65.257,
    cy: 65.1367,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ab",
    cx: 65.257,
    cy: 65.1367,
    r: 57.7278
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "ac",
    x1: 20.1525,
    y1: 110.2412,
    x2: 110.2412,
    y2: 20.1525
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceJr);
export default __webpack_public_path__ + "static/media/space-JR.bbad67362c9649afd58c1f3b421cf611.svg";
export { ForwardRef as ReactComponent };